import React from 'react';
import styled, { css } from 'styled-components';
import { formatMessage } from '@99designs/frontend-components/i18n';
import Image from '../../../components/Image';
import { avatars, colors } from '../../../settings';

export type AvatarSize =
    | 'extra-small'
    | 'small'
    | 'medium'
    | 'large'
    | 'extra-large'
    | 'extra-extra-large';

interface AvatarStyleProps {
    size: AvatarSize;
}

const StyledAvatar = styled.span<AvatarStyleProps>`
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    width: ${({ size }) => avatars.sizes[size].avatarSize}px;
    height: ${({ size }) => avatars.sizes[size].avatarSize}px;
`;

const StyledImage = styled(Image)`
    border-radius: 50%;
`;

interface IndicatorStyleProps {
    size: AvatarSize;
}
const Indicator = styled.div<IndicatorStyleProps>`
    position: absolute;
    background: ${colors.forrestLyf};
    border-radius: 50%;
    border: 2px solid ${colors.white};
    ${({ size }) => css`
        right: ${avatars.sizes[size].indicatorPositioning}px;
        bottom: ${avatars.sizes[size].indicatorPositioning}px;
        width: ${avatars.sizes[size].indicatorSize}px;
        height: ${avatars.sizes[size].indicatorSize}px;
        border-width: ${size === avatars.size.Small ? 1 : 2}px;
    `}
`;
export interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
    avatarUrl: string;
    online?: boolean;
    size?: AvatarSize;
    userName?: string;
}

export function Avatar({
    avatarUrl,
    size = 'medium',
    online = false,
    userName,
    ...rest
}: AvatarProps) {
    return (
        <StyledAvatar size={size} {...rest}>
            <StyledImage
                src={avatarUrl}
                alt={
                    userName &&
                    formatMessage(__('The avatar of {userName}'), {
                        userName: userName,
                    })
                }
            />
            {online && <Indicator size={size} />}
        </StyledAvatar>
    );
}
